import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.monitoring.common.eggprice');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';

@Component({
    selector: 'wiz-portal-monitoring-common-eggprice',
template: templateSource || '',
    styles: [``],
})
export class PortalMonitoringCommonEggpriceComponent implements OnInit, OnDestroy {

    public list: any[] = [];
    public page = 1;
    public lastPage = 1;
    public loading = false;

    public graphData: any = null;
    private graphLoaded = false;

    private routeSub: Subscription;

    constructor(@Inject( Router)         private router: Router,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Service    )         public service: Service    ) { }

    public async ngOnInit() {
        await this.service.init();

        this.routeSub = this.route.queryParams.subscribe(async params => {
            this.page = Number(params['page']) || 1;
            await this.load();
            await this.service.render();
        });
    }

    ngOnDestroy() {
        if (this.routeSub) this.routeSub.unsubscribe();
    }

    private async load() {
        this.loading = true;
        await this.service.render();
        try {
            const res = await wiz.call('search', { page: this.page });
            if (!res || res.code !== 200) return;

            this.list = res.data.list || [];
            this.lastPage = res.data.lastpage || 1;

            if (!this.graphLoaded) {
                await this.loadGraph();
                this.graphLoaded = true;
            }
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private async loadGraph() {
        const res = await wiz.call('graph');
        if (!res || res.code !== 200) return;

        const labels: string[] = [];

        const datasets = [
            {
                label: '왕란',
                data: [] as (number | null)[],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#f69232',
                borderColor: '#f69232',
                tension: 0.15
            },
            {
                label: '특란',
                data: [] as (number | null)[],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#8b5cf6',
                borderColor: '#8b5cf6',
                tension: 0.15
            },
            {
                label: '대란',
                data: [] as (number | null)[],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#38bdf8',
                borderColor: '#38bdf8',
                tension: 0.15
            },
            {
                label: '중란',
                data: [] as (number | null)[],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#10b981',
                borderColor: '#10b981',
                tension: 0.15
            }
        ];

        res.data.forEach((item: any) => {
            labels.push(item.date.substring(0, 10));
            datasets[0].data.push(item.egg1 ?? null);
            datasets[1].data.push(item.egg2 ?? null);
            datasets[2].data.push(item.egg3 ?? null);
            datasets[3].data.push(item.egg4 ?? null);
        });

        this.graphData = {
            title: '계란시세 그래프',
            labels,
            datasets,
            options: {
                plugins: {
                    legend: {
                        position: 'right'
                    }
                }
            }
        };
    }

    public onPageChange = (page: number) => {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { page },
            queryParamsHandling: 'merge'
        });
    };

}

export default PortalMonitoringCommonEggpriceComponent;